var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvcIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 65C14.485 65 10 60.515 10 55V27.5C10 21.985 14.485 17.5 20 17.5C22.07 17.5 23.75 19.1775 23.75 21.25C23.75 23.3225 22.07 25 20 25C18.62 25 17.5 26.1225 17.5 27.5V55C17.5 56.3775 18.62 57.5 20 57.5C22.07 57.5 23.75 59.1775 23.75 61.25C23.75 63.3225 22.07 65 20 65Z",
    fill: "#38383D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 65C57.93 65 56.25 63.3225 56.25 61.25C56.25 59.1775 57.93 57.5 60 57.5C61.38 57.5 62.5 56.3775 62.5 55V27.5C62.5 26.1225 61.38 25 60 25C57.93 25 56.25 23.3225 56.25 21.25C56.25 19.1775 57.93 17.5 60 17.5C65.515 17.5 70 21.985 70 27.5V55C70 60.515 65.515 65 60 65Z",
    fill: "#38383D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.25 37.5H28.75C26.68 37.5 25 35.8225 25 33.75C25 31.6775 26.68 30 28.75 30H51.25C53.32 30 55 31.6775 55 33.75C55 35.8225 53.32 37.5 51.25 37.5Z",
    fill: "#9AFF42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 52.5H28.75C26.68 52.5 25 50.8225 25 48.75C25 46.6775 26.68 45 28.75 45H43.75C45.82 45 47.5 46.6775 47.5 48.75C47.5 50.8225 45.82 52.5 43.75 52.5Z",
    fill: "#9AFF42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvcIcon1);
export default __webpack_public_path__ + "static/media/svc_icon1.66e105742d067bccbc8e2f14a5d6cac6.svg";
export { ForwardRef as ReactComponent };